import React, { Fragment } from "react";
import styled from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";

const ActionBar = ({
  actions = [],
  breadcrumbs = [],
  onBreadcrumbClick = () => {},
}) => {
  return (
    <ActionBarContainer>
      <Breadcrumbs>
        {breadcrumbs.map((breadcrumb, index) => (
          <Fragment key={`breadcrumb-${breadcrumb}-${index}`}>
            <Breadcrumb onClick={() => onBreadcrumbClick(breadcrumbs[index])}>
              {breadcrumb}
            </Breadcrumb>
            {index < breadcrumbs.length - 1 && <Breadcrumb>{">"}</Breadcrumb>}
          </Fragment>
        ))}
      </Breadcrumbs>
    </ActionBarContainer>
  );
};

export default ActionBar;

const ActionBarContainer = styled.div`
  // border-bottom: 1px solid ${COLORS.BORDER_GREY};
  padding: 20px 53px 0 35px;
  display: flex;
  align-items: center; //   border-bottom: 1px solid ${COLORS.BORDER_GREY};
  height: 75px;
  justify-content: center;
`;

const Breadcrumbs = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Breadcrumb = styled.div`
  font-size: 18px;
  font-weight: 900;
  font-family: ${theme.fonts.primaryFontExtraBold};
  margin-right: 4px;
  cursor: pointer;
  color: ${COLORS.LIGHT_BLUE_LABEL};
  user-select: none;
`;
